import { Box, VStack, HStack, Text, IconButton } from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';
import IconWrapper from './IconWrapper';
import { ContentItem } from '../services/contentService';

interface VideoEpisodesProps {
  showEpisodes: boolean;
  episodes: ContentItem[];
  isLoadingEpisodes: boolean;
  onClose: () => void;
  onEpisodeClick: (episode: ContentItem) => void;
}

const VideoEpisodes: React.FC<VideoEpisodesProps> = ({
  showEpisodes,
  episodes,
  isLoadingEpisodes,
  onClose,
  onEpisodeClick
}) => {
  if (!showEpisodes) return null;

  return (
    <Box
      position="fixed"
      right="0"
      top="60px"
      bottom="0"
      width="400px"
      bg="rgba(0, 0, 0, 0.95)"
      backdropFilter="blur(10px)"
      borderLeft="1px solid"
      borderColor="gray.600"
      zIndex={1000}
      display="flex"
      flexDirection="column"
    >
      <VStack align="stretch" p={6} pt={8} gap={4} flex="1" overflow="hidden">
        <HStack justify="space-between" align="center" flexShrink={0}>
          <Text fontSize="xl" fontWeight="bold" color="white">
            Episodes
          </Text>
          <IconButton
            aria-label="Close episodes"
            icon={<IconWrapper icon={FiArrowLeft} size={20} />}
            size="sm"
            variant="ghost"
            colorScheme="white"
            onClick={onClose}
          />
        </HStack>

        {isLoadingEpisodes ? (
          <VStack align="center" gap={4} py={8} flex="1">
            <Text color="gray.400">Loading episodes...</Text>
          </VStack>
        ) : episodes.length === 0 ? (
          <VStack align="center" gap={4} py={8} flex="1">
            <Text color="gray.400">No episodes available</Text>
          </VStack>
        ) : (
          <Box flex="1" overflowY="auto" pr={2}>
            <VStack align="stretch" gap={3}>
              {episodes.map((episode, index) => (
                <Box
                  key={episode.id}
                  p={4}
                  bg="rgba(255, 255, 255, 0.05)"
                  borderRadius="lg"
                  border="1px solid"
                  borderColor="gray.600"
                  cursor="pointer"
                  _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                  onClick={() => onEpisodeClick(episode)}
                >
                  <HStack align="start" gap={3}>
                    <Box
                      w="60px"
                      h="40px"
                      bg="gray.700"
                      borderRadius="md"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      color="gray.400"
                      fontSize="sm"
                      fontWeight="bold"
                    >
                      {index + 1}
                    </Box>
                    
                    <VStack align="start" gap={1} flex="1">
                      <Text color="white" fontWeight="semibold" fontSize="sm">
                        {episode.title}
                      </Text>
                      <Text color="gray.400" fontSize="xs">
                        Episode {index + 1}
                      </Text>
                      {episode.duration && (
                        <Text color="gray.500" fontSize="xs">
                          {Math.floor(episode.duration / 60)}:{(episode.duration % 60).toString().padStart(2, '0')}
                        </Text>
                      )}
                    </VStack>
                    
                  </HStack>
                </Box>
              ))}
            </VStack>
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default VideoEpisodes;
